import axios from '@/libs/api.request'



var project={
    
}

project.addProject = (r) => {
    return axios.request({
      url: 'api/Project/Add',
      data:r,
      method: 'post'
    })
  }

  project.updateProject = (r) => {
    return axios.request({
      url: 'api/Project/Update',
      data:r,
      method: 'post'
    })
  }

  project.projectList = (query) => {
    return axios.request({
      url: 'api/Project/List',
      params:query,
      method: 'get'
    })
  }


  // project.addRProject = (r) => {
  //   return axios.request({
  //     url: 'api/RProject/Add',
  //     data:r,
  //     method: 'post'
  //   })
  // }

  // project.updateRProject = (r) => {
  //   return axios.request({
  //     url: 'api/RProject/Update',
  //     data:r,
  //     method: 'post'
  //   })
  // }

  // project.rprojectList = (query) => {
  //   console.log(query);
  //   return axios.request({
  //     url: 'api/RProject/List',
  //     params:query,
  //     method: 'get'
  //   })
  // }

  project.deleteProject = (r) => {
    return axios.request({
      url: 'api/Project/Delete/'+r,
      method: 'post'
    })
  }
  
  project.addProjectType=(r)=>{
	  return axios.request({
	    url: 'api/Project/AddProjectType',
	    data:r,
	    method: 'post'
	  })
  }
  
  project.getProjectTypeList=(r)=>{
  	  return axios.request({
  	    url: 'api/Project/ProjectTypeList',
  	    method: 'get'
  	  })
  }
  
  project.deleteProjectType=(r)=>{
  	  return axios.request({
  	    url: 'api/Project/DeleteProjectType/'+r,
  	    method: 'post'
  	  })
  }

export default project;